import React from 'react'
import clsx from 'clsx'
import { CloseCircle, Paperclip } from 'iconsax-react'
import { useTheme } from '@mui/material'

import useStyles from './styles'

interface AttachedFileProps {
  file: File
  onDelete: () => void
}
const AttachedFile: React.FC<AttachedFileProps> = ({ file, onDelete }) => {
  const theme = useTheme()

  const isAudioNote = React.useMemo(
    () => file?.name && file?.name === 'audio-note.wav',
    [file]
  )
  const url = React.useMemo(
    () => (isAudioNote ? URL.createObjectURL(file) : ''),
    [file, isAudioNote]
  )

  const classes = useStyles()

  return file?.name ? (
    <div className={classes.root}>
      {/* only play voice notes. */}
      {isAudioNote ? (
        <audio controls src={url} className={classes.audio} />
      ) : (
        <>
          <Paperclip size={theme.size.base} className={classes.icon} />
          <label>{file.name}</label>
        </>
      )}

      <div
        className={clsx(classes.deleteContainer, 'delete-container')}
        title='Delete file'
      >
        <CloseCircle
          size={theme.size.base}
          onClick={onDelete}
          className={classes.delete}
        />
      </div>
    </div>
  ) : null
}

export default React.memo(AttachedFile)
